import Vue from 'vue'
import VueRouter from 'vue-router'
import RouteGuard from '../router/routeGuard.js'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    beforeEnter: RouteGuard
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    beforeEnter: RouteGuard
  },
  {
    path: '/members',
    name: 'Team',
    component: () => import('../views/Team.vue'),
    beforeEnter: RouteGuard
  },
  {
    path: '/members/:id',
    name: 'Member',
    props: true,
    component: () => import('../components/Member/Member.vue'),
    beforeEnter: RouteGuard
  },
  {
    path: '/createmember',
    name: 'Create Member',
    component: () => import('../components/Member/CreateMember.vue'),
    beforeEnter: RouteGuard
  },
  {
    path: '/calendar',
    name: 'Calendar',
    component: () => import('../views/Calendar.vue'),
    beforeEnter: RouteGuard
  },
  {
    path: '/calendarevent/:id',
    name: 'Calendar Event',
    component: () => import('../components/Calendar/ShowCalendarEvent.vue'),
    props: true,
    beforeEnter: RouteGuard
  },
  {
    path: '/addcalendarevent',
    name: 'Add Calendar Event',
    component: () => import('../components/Calendar/AddCalendarEvent.vue'),
    beforeEnter: RouteGuard
  },
  {
    path: '/idealist',
    name: 'Voting Ballot',
    component: () => import('../views/VotingBallot.vue'),
    beforeEnter: RouteGuard
  },
  {
    path: '/addvideoidea',
    name: 'Add Video Idea',
    component: () => import('../components/Vote/AddIdea.vue'),
    beforeEnter: RouteGuard
  },
  {
    path: '/equipmentlist',
    name: 'Resource List',
    component: () => import('../views/ResourceList.vue'),
    beforeEnter: RouteGuard
  },
  {
    path: '/equipment/:id',
    name: 'Equipment',
    props: true,
    component: () => import('../components/Resource/Equipment.vue'),
    beforeEnter: RouteGuard
  },
  {
    path: '/addequipment',
    name: 'Add Equipment',
    component: () => import('../components/Resource/AddEquipment.vue'),
    beforeEnter: RouteGuard
  },
  {
    path: '/youtubestatistics',
    name: 'YouTube Statistics',
    component: () => import('../views/YouTubeStatistics.vue'),
    beforeEnter: RouteGuard
  },
  {
    path: '/youtubestatistics/:id',
    name: 'Statistics',
    props: true,
    component: () => import('../components/ChannelStat/Stat.vue'),
    beforeEnter: RouteGuard
  },
  {
    path: '/login',
    name: 'Log in',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/signup',
    name: 'Sign up',
    component: () => import('../views/Signup.vue')
  },
  {
    path: '*',
    name: 'Error',
    component: () => import('./Error.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
